export enum ConfirmationActionEnum {
  APPROVE = "APPROVE",
  DECLINE = "DECLINE"
}
